import React from 'react';

import List from '../List'

const MaterialList = ({sewpat}) => {
    return (
        <List items={sewpat.material} />
    );
};

export default MaterialList;



// WEBPACK FOOTER //
// ./src/components/sewpat/MaterialList.js